import { Box, HStack,Text,theme } from '@bpba/ui-components';
import { Urls } from '../utils/Url';

export const VideoCDNIComercios = () => {
  return (
    <Box  marginY={"30px"} flexDirection={["column","column","row","row"]} height={["auto", "auto","28rem", "28rem"]} alignItems={"center"} marginBottom={"6rem"}>
      <Box width={'100%'} flexDirection={["column","column","row","row"]} height={["auto","auto","380px","280px"]} backgroundColor={["transparent","transparent","#e0e0e0","#e0e0e0"]} >
      <Box width={["100%","100%","65%","70%"]} flexDirection={"column"} paddingRight={["0","0","40px","40px"]}>
      <Text
              fontSize={"26px"}
              color={theme.colors.primary[0]}
              lineHeight={['33px', '33px', '33px', '33px']}
              margin={0}
              marginTop={["40px","40px","40px","40px"]}
              marginLeft={["0","0","80px","80px"]}
              tabIndex={0}
              fontWeight={"bold"}
              textAlign={["center","center","start","start"]}
            >
             Los comerciantes eligen la app todos los días
            </Text>
            <Text fontSize={'20px'} marginLeft={["0","0","80px","80px"]} lineHeight={["31px","31px","28px","28px"]} tabIndex={0} textAlign={["center","center","start","start"]}>
              Hacé click en el video y descubrí los beneficios que Cuenta DNI Comercios tiene para incrementar tus ventas.
            </Text>
            <Text
              fontSize={"26px"}
              color={"#279d2fda"}
              lineHeight={['33px', '33px', '33px', '33px']}
              marginLeft={["0","0","80px","80px"]}
              tabIndex={0}
              marginTop={0}
              textAlign={["center","center","start","start"]}
            >
             Formá parte de la comunidad que no para de crecer.
            </Text>
            </Box>
      <Box width={['100%','100%','35%','30%']} height={"100%"} alignItems={'center'} justifyContent={["center","center","start","start"]} marginTop={"40px"}>
      <Box width={['320px', '320px', '250px', '235px']} height={["600px","600px","28rem", "28rem"]} border={'4px solid #25B4BD'} borderRadius={'3px 12px'}>
          <div style={{ paddingBottom: '56.25%'}} >
            <iframe
              title="video-modal"
              style={{ position: 'absolute', borderRadius:"1px 10px" }}
              width="100%"
              height="100%"
              src={Urls.getYoutubeEmbedUrl('aGWU4ndHZ6c?feature=share')}
              allow="autoplay"
              allowFullScreen={true}
              
            />
          </div>
        </Box>
      </Box>
      </Box>
    </Box>
  );
};
